import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetCountryList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Country/GetList?` + params, null);

  export const GetCountryListForSelect = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Country/GetListForSelect?` + params, null);